declare global {
  interface Window {
    _genesys: any;
    Genesys: any;
  }
}

export namespace LiveChat {
  let livechatStartAttempt = 0;

  export function initialise() {
    if (!window['_genesys'] && !window.Genesys) {
      console.log('Live chat not initialised, not starting');
      setTimeout(() => {
        livechatStartAttempt += 1;

        if (livechatStartAttempt <= 3) {
          initialise();
        }
      }, 500);
      return;
    }

    window._genesys = {
      widgets: {
        main: {
          preload: ['webchat'],
        },
        webchat: {
          autoInvite: false, // 🚫 No proactive popup
          autoDisplay: false, // 🚫 No auto open chat
        },
        messenger: {
          autoShow: false, // 🚫 No auto show messenger
        },
        launcher: {
          autoShow: false, // 🚫 No auto show launcher
        },
      },
    };

    window.Genesys('subscribe', 'Messenger.ready', () => {
      showLiveChatLauncher();
    });
    window.Genesys('subscribe', 'Messenger.closed', () => {
      showLiveChatLauncher();
    });
  }

  export function showLiveChatLauncher() {
    if (!window.Genesys) return;
    window.Genesys('command', 'Launcher.show');
  }

  export function hideLiveChatLauncher(): void {
    if (!window.Genesys) {
      setTimeout(() => {
        hideLiveChatLauncher();
      }, 500);
      return;
    }
    window.Genesys('command', 'Launcher.hide');
  }

  export function openLiveChat(): void {
    if (!window.Genesys) return;

    window.Genesys('command', 'Launcher.hide');
    window.Genesys('command', 'Messenger.open');
  }
}
